import { TENANT, Tenant } from './tenant';

interface TenantImprintConfig {
  companyName: string;
  addressLines: string[];
  representatives: string[];
  registerLines: string[];
  taxId?: string;
  contactFormUrl?: string;
  generalEmail?: string;
  jobsEmail?: string;
  phone?: string;
  fax?: string;
  dataProtectionOfficerEmail?: string;
  dataProtectionAuthority?: string[];
}

const tenantImprintMap = new Map<Tenant, TenantImprintConfig>([
  [
    Tenant.avelios,
    {
      companyName: 'Avelios Medical GmbH',
      addressLines: ['Ridlerstraße 39', '80339 München', 'Deutschland'],
      representatives: ['Christian Albrecht', 'Nicolas Jakob'],
      registerLines: ['Handelsregister München', 'HRB 270765'],
      taxId: 'DE334616294',
      contactFormUrl: 'https://avelios.com/kontakt/?lang=de',
      generalEmail: 'info@avelios.com',
      jobsEmail: 'recruiting@avelios.com',
    },
  ],
  [
    Tenant.sana,
    {
      companyName: 'Sana IT Services GmbH',
      addressLines: ['Adalperostraße 31', '85737 Ismaning'],
      representatives: ['Tobias Eimermacher', 'Wolfgang Grill'],
      registerLines: ['Amtsgericht München, HRB 116522'],
      taxId: 'DE814812986',
      phone: '+49 089 678204-0',
      fax: '+49 089 678204-179',
      dataProtectionOfficerEmail: 'sit-datenschutz@sana.de',
      dataProtectionAuthority: [
        'Bayerisches Landesamt für Datenschutzaufsicht (BayLDA)',
        'Promenade 18',
        '91522 Ansbach',
      ],
    },
  ],
]);

export const TENANT_IMPRINT = tenantImprintMap.get(TENANT)!;
